import { sapApi } from "@/apis/interceptor"
import { IResponse, IWbsMaster } from "@/types"

interface IWbsMasterAutocompleteResponse {
  items: IWbsMaster[]
}

export const wbsMasterService = {
  getAutocompleteOptions: async (search: string, limit = 10): Promise<IResponse<IWbsMasterAutocompleteResponse>> => {
    const response = await sapApi.get<IResponse<IWbsMasterAutocompleteResponse>>("/api/v1/wbs-masters/autocomplete", {
      params: { search, limit },
    })
    return response.data
  },
}
